<div class="org-and-stockroom d-flex align-items-center">
  <mat-card class="org-stockroom-card">
      <mat-card-title class="mb-5">
          <div class="avantor-title d-flex flex-row justify-content-space-around align-items-end">
              <img src="/images/Avantor IM Logo Horizontal.svg" alt="" srcset="">
          </div>
          <h4 class="im-acc">No Inventory Manager Account</h4>

      </mat-card-title>
      <mat-card-content>

          <form>
            <h6>Log in with different profile:</h6>
              <div class="d-flex flex-column justify-content-space-around align-items-stretch">
                  <button 
                      mat-raised-button 
                      color="primary" 
                      class="w-100 py-1 login" 
                      (click)="forceLogout()">
                      <span> Login </span>
                  </button>
                  <div class="footer">
                      For support with Inventory Manager, including but not limited to<br>
                      access and password resets, please email<br>
                      DigitalTechSupport&#64;avantorsciences.com or call 1-888-793-2300
                  </div>
              </div>
          </form>
      </mat-card-content>
  </mat-card>
</div>
